import PropTypes from 'prop-types'
import React, { Component } from 'react'
import styles from './badges-group.styl'
import { get } from 'lodash'
import { getBadgeIconImg } from '../../../helpers/badgeHelper'
import { FormattedMessage } from 'react-intl'


class BadgeGroup extends Component {
  static propTypes = {
    badges: PropTypes.object.isRequired,
    awardBadges: PropTypes.object.isRequired,
    badgesProgress: PropTypes.object.isRequired,
    award: PropTypes.object.isRequired,
    activity: PropTypes.object.isRequired,
    isBadgesStrictModeEnabled: PropTypes.object.isRequired
  }

  getBadgeIcon = (awardBadges, badge) => {
    const isObtained = awardBadges.filter(awardBadge => get(awardBadge, 'badge.id') === get(badge, 'id')).length > 0

    return isObtained ? 'badgeIconObtained' : 'badgeIcon'
  }


  getBadgeDescription = badgeCfg => {
    const descCfg = badgeCfg && badgeCfg.filter(cfg => {
      return 'DESCRIPTION' in cfg
    })

    return descCfg && descCfg[0]['DESCRIPTION']
  }

  getPredictionForFinishBadge = (badge, badgesProgressBySection) => {
    const badgeLvl = get(badge, 'badgeLevel.value')

    return badgesProgressBySection && badgesProgressBySection[badgeLvl] && get(badgesProgressBySection[badgeLvl], 'weeksToFinish') || 0
  }

  getBadgeDescription = (badge, badgesProgressBySection) => {
    const badgeLvl = get(badge, 'badgeLevel.value')

    return badgesProgressBySection && badgesProgressBySection[badgeLvl] && get(badgesProgressBySection[badgeLvl], 'description') || ''
  }

  render() {
    const { badges, awardBadges, badgesProgress, award, activity } = this.props

    const badgesData = get(badges, 'badges')

    const activitySection = get(activity, 'activitySection.value')

    const filteredAwardBadges = awardBadges.filter(ab => get(ab, 'activitySection.value') === activitySection)

    const badgesProgressBySection = get(badgesProgress, 'progressValues') && get(badgesProgress, 'progressValues')[activitySection]

    const groupName = badgesData && badgesData.length > 0 && get(badgesData[0], 'badgeGroup.name.translationText')

    const groupDesc = badgesData && badgesData.length > 0 && get(badgesData[0], 'badgeGroup.description')

    return (
      <div className={styles.badgeGroupWrapper}>
       <div className={styles.groupDescription}>
        <h2>{groupName}</h2>
        <p>{groupDesc}</p>
       </div>

        { badgesData && badgesData.map(badge => {

          const classKey = this.getBadgeIcon(filteredAwardBadges, badge)

          const weeksToAchieve = this.getPredictionForFinishBadge(badge, badgesProgressBySection)

          const badgeDescription = this.getBadgeDescription(badge, badgesProgressBySection)

          const isBadgeObtained = weeksToAchieve > 0

          const badgeIconImg = getBadgeIconImg(award, badge, !isBadgeObtained)

          return(
            <div className={ isBadgeObtained ? styles.badgeProgress : styles.withoutBadgeProgress}>
              {weeksToAchieve > 0 && <div className={styles.title}>
                <FormattedMessage
                   id="label.badge_to_achieve_count"
                   defaultMessage="{weeksToAchieve} weeks to"
                   values={{
                     weeksToAchieve: weeksToAchieve
                  }}
                />
              </div>}
              <div className={styles.badgeWrapper}>
                <div className={`${styles[classKey]}`}>
                  <img src={`data:image/png;base64, ${badgeIconImg}`} />
                </div>
                <div className={styles.badgeDescriptionWrapper}>
                  <h4>{get(badge, 'badgeLevel.translationText')}</h4>
                  <div className={styles.badgeDescription}>
                        <span>
                          {badgeDescription}
                      </span>
                  </div>
                </div>
              </div>
              <div className={styles.clear}></div>
            </div>
          )
        })}
      </div>
    )
  }
}

export default BadgeGroup
